// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1eE8R","img":"Card_img__qr-qd","name":"Card_name__1qjZb","weight":"Card_weight__218px","weightProps":"Card_weightProps__1Vt1E","enlace":"Card_enlace__IrP2P"};